import { CheckBoxFilter } from '@shared/components/CheckboxFilter';

import { FlowerStatItem } from './flowerStat.interface';

/**
 * 소속(teamType) 필터 칩에 표시할 라벨 맵을 생성한다.
 *
 * 특정 teamType에 속한 데이터의 teamName이 한 종류뿐이면(예: 지사가 한 곳뿐),
 * 일반 분류명(지사) 대신 그 teamName(지사 이름)을 칩 라벨로 사용한다.
 * 두 곳 이상이면 분류명을 그대로 보여준다.
 *
 * 필터링 자체는 teamType 키로 동작하므로 라벨은 표시용으로만 쓰인다.
 */
export const getSingleTeamNameLabels = (
  flowerStatList: FlowerStatItem[],
  teamTypesFilter: CheckBoxFilter | null,
): { [teamType: string]: string } => {
  const labels: { [teamType: string]: string } = {};
  if (!teamTypesFilter) return labels;

  Object.keys(teamTypesFilter).forEach((teamType) => {
    const teamNames: string[] = [];
    flowerStatList.forEach((item) => {
      if (
        item.teamType === teamType &&
        item.teamName &&
        !teamNames.includes(item.teamName)
      ) {
        teamNames.push(item.teamName);
      }
    });
    const singleTeamName = teamNames[0];
    if (teamNames.length === 1 && singleTeamName) {
      labels[teamType] = singleTeamName;
    }
  });

  return labels;
};
